import { useCallback, useEffect, useState } from 'react';
import { DealsService } from 'service/deals.service';
import { FilterOption } from '../DealsFilters.types';

export const useOwnerOptions = () => {
  const [ownerOptions, setOwnerOptions] = useState<FilterOption[]>([]);
  const [loading, setLoading] = useState(false);
  const [totalLength, setTotalLength] = useState(0);

  const fetchOwners = useCallback(async () => {
    try {
      setLoading(true);
      const data = await DealsService.getMembers();
      const members = data?.members || (Array.isArray(data) ? data : []);
      const formattedOwners = members
        .map((item: any) => ({
          Name: `${item.firstName} ${item.lastName}` || '',
          Id: item.email || '',
        }))
        .filter((item: any) => item.Name && item.Id);
      setOwnerOptions(formattedOwners);
      setTotalLength(formattedOwners.length);
    } catch (error) {
      console.error('Failed to fetch owners', error);
      setOwnerOptions([]);
      setTotalLength(0);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchOwners();
  }, [fetchOwners]);

  const filterOwners = useCallback(
    (searchValue: string) => {
      if (!searchValue) return ownerOptions;
      return ownerOptions.filter((owner) =>
        owner.Name.toLowerCase().includes(searchValue.toLowerCase()),
      );
    },
    [ownerOptions],
  );

  return {
    ownerOptions,
    loading,
    totalLength,
    filterOwners,
  };
};
